import { useEffect, useMemo } from 'react';

import { useLazyQuery } from '@apollo/client';

import { IS_USER_ADMIN } from 'config/graphql/queries';
import { useUserManagementContext } from 'hooks/userManagement/useUserManagementContext';
import { isStandalone } from 'utils/environment';

export enum Permissions {
  None = 0,
  SUPER_ADMINISTRATOR = 1,
  ADMINISTRATOR = 2,
  DASHBOARD_ADMINISTRATOR = 4,
  GATED_ACCESS_ADMINISTRATOR = 8,
}

export const hasPermission = (flag: Permissions, systemRoles = 0) => (systemRoles & flag) === flag;

export const useFetchUserPermissions = (tournamentId?: string) => {
  const [fetchPermissions, { data, loading }] = useLazyQuery(IS_USER_ADMIN, {
    fetchPolicy: isStandalone() ? 'cache-only' : 'cache-first',
  });

  useEffect(() => {
    if (tournamentId) fetchPermissions({ variables: { tournamentId } });
  }, [tournamentId, fetchPermissions]);

  const systemRoles = useUserManagementContext()?.user?.SystemRoles ?? 0;
  return useMemo(
    () => ({
      isAdminOrSuperAdmin: !!(isStandalone() || data?.isUserAdminWithTournamentScope),
      isSuperAdmin: hasPermission(Permissions.SUPER_ADMINISTRATOR, systemRoles),
      loading,
    }),
    [data?.isUserAdminWithTournamentScope, loading, systemRoles],
  );
};

export default useFetchUserPermissions;
